export default __webpack_public_path__ + "media/images/icons/btc-e4819592f61f231e0df2ef4270bbf203.png";